import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-black-lp-300 text-base font-semibold" }
const _hoisted_2 = { class: "flex flex-col gap-y-4" }
const _hoisted_3 = { class: "flex items-center gap-x-2.5" }
const _hoisted_4 = { class: "text-black-lp-300 text-sm font-semibold" }
const _hoisted_5 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_6 = {
  class: "flex flex-col gap-y-2 my-2 overflow-y-auto",
  style: {"max-height":"261px"}
}
const _hoisted_7 = { class: "flex items-center justify-end gap-x-2.5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CardAddTemplate = _resolveComponent("CardAddTemplate")!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        onClose: _ctx.onClose,
        width: "w-800px",
        isCustomTitle: "",
        titlePadding: "px-6 py-2",
        contentPadding: "px-6 py-2"
      }, {
        "custom-title": _withCtx(() => [
          _createVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('pusatResolusi.history.addTemplateTitle')), 1)
        ]),
        content: _withCtx(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('pusatResolusi.newMessage'),
              fontSize: "14",
              class: "col-span-2 w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  type: "textarea",
                  showMaxLength: "",
                  textAreaRows: "1",
                  modelValue: _ctx.newTemplate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newTemplate = $event)),
                  error: _ctx.isFocusNewTemplate,
                  isErrorIconCaption: false,
                  placeholder: _ctx.$t('pusatResolusi.newMessagePlaceholder'),
                  maxLength: _ctx.maxLengthNewTemplate,
                  disabled: _ctx.disabledNewTemplate,
                  disableBackground: _ctx.disabledNewTemplate,
                  preventEnterTextArea: "",
                  onEnter: _ctx.onAdd,
                  onFocus: _ctx.onFocusNewTemplate,
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isFocusNewTemplate = false))
                }, {
                  counter: _withCtx(() => [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("p", {
                        class: 
                    `text-12px text-gray-lp-500 ${
                      _ctx.disabledNewTemplate ? 'bg-gray-lp-1500' : ''
                    }`
                  
                      }, _toDisplayString(_ctx.newTemplate.length) + "/" + _toDisplayString(_ctx.maxLengthNewTemplate), 3),
                      _createVNode(_component_Icons, {
                        name: "chat",
                        class: "w-4 text-gray-lp-600"
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "error", "placeholder", "maxLength", "disabled", "disableBackground", "onEnter", "onFocus"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, null, {
              label: _withCtx(() => [
                _createVNode("span", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t('pusatResolusi.messageTemplateList')) + " ", 1),
                  _createVNode("span", _hoisted_5, " (" + _toDisplayString(_ctx.templateList.length) + "/8) ", 1)
                ])
              ]),
              default: _withCtx(() => [
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_Draggable, {
                    modelValue: _ctx.templateList,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.templateList = $event)),
                    tag: "transition-group",
                    "item-key": "position",
                    onChange: _ctx.onDrag
                  }, {
                    item: _withCtx(({element, index}) => [
                      _createVNode(_component_CardAddTemplate, {
                        data: element,
                        index: index,
                        onDelete: _ctx.onDelete
                      }, null, 8, ["data", "index", "onDelete"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        footer: _withCtx(() => [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_LpButton, {
              id: "button_close_modal_add_pesan_cepat",
              title: _ctx.$t('pusatResolusi.review.cancel'),
              outline: "",
              "text-color": "red-lp-100",
              onClick: _ctx.onClose,
              customClass: "px-10"
            }, null, 8, ["title", "onClick"]),
            _createVNode(_component_LpButton, {
              id: "button_submit_modal_add_pesan_cepat",
              title: _ctx.$t('pusatResolusi.review.save'),
              "text-color": "white",
              disabled: _ctx.disabledSave,
              onClick: _ctx.onSave,
              customClass: "px-10"
            }, null, 8, ["title", "disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}